import * as types from '../actions/types'

const initialState = {
  source: '/',
  html5: false
}

export default function (state=initialState, action) {

  switch (action.type) {
    case types.SET_SOURCE:
      return Object.assign({}, state, {
        source: action.source
      })

    case types.SET_HTML5:
      return Object.assign({}, state, {
        html5: action.enabled
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/audioPlayer.js